// extracted by mini-css-extract-plugin
export default {"counter":"ItemsCounter_counter__OjH4N"};